export const promiseEnums = {
  ready: 0,
  pending: 1,
  errored: 2,
  success: 3,
};
